import { Component, OnDestroy, ViewEncapsulation } from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
// Central Content Service --- -------
import { CentralContentService } from 'src/app/services/content/central-content.service'
// -----------------------------------
import { environment } from 'src/environments/environment'

import { ContentService } from '../../../../services/content/content.service'
import { DisclaimersService } from './disclaimers.service'
@Component({
  selector: 'disclaimers',
  templateUrl: './disclaimers.component.html',
  styleUrls: ['./disclaimers.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DisclaimersComponent implements OnDestroy {
  disclaimersSubscription: Subscription
  disclaimersModel: any
  personalLink = environment.externalUrl
  plainTalk: AEMChunk
  isETF: boolean
  isInternal: boolean
  isExternal: boolean
  isMutualFund: boolean
  is529: boolean
  isMoneyMarket: boolean
  isTaxExempt: boolean
  isREITFund: boolean
  secDesignation: string
  morningstarAllRightsReserved: AEMChunk
  etfSharesRedeemable: AEMChunk
  etfVanguardAverageExpenseRatio: AEMChunk
  mfVanguardAverageExpenseRatio: AEMChunk
  p529ProgramDescriptionLink1: AEMChunk
  p529ProgramDescription: AEMChunk
  p529ProgramDescriptionLink2: AEMChunk
  mfTaxableMoneyMarketLoseMoney: AEMChunk
  mfTaxExemptMoneyMarketLoseMoney: AEMChunk
  p529TaxExemptMoneyMarketLoseMoney: AEMChunk
  mfInvestingSubjectToRisk: AEMChunk

  externalAssetClassRisks: AEMChunk
  externalThirdPartyCalculations: AEMChunk
  externalMFDataSources: AEMChunk
  externalMFFeesMinimums: AEMChunk
  externalMFInvestingProspectus: AEMChunk

  updatedLink: string
  newEtfSplit: string
  aemContentSub: Subscription

  constructor(
    private readonly centralContentService: CentralContentService,
    private readonly contentService: ContentService,
    private readonly disclaimersService: DisclaimersService,
  ) {}

  /* eslint max-statements: [2, 30] */
  ngOnInit() {
    this.disclaimersSubscription = this.disclaimersService
      .getModelData()
      .subscribe((model) => {
        this.disclaimersModel = model
        this.plainTalk = this.disclaimersModel.risk?.plainTalk
        this.isETF = this.disclaimersModel.profile?.isETF
        this.isMutualFund = this.disclaimersModel.profile?.isMutualFund
        this.is529 = this.disclaimersModel.profile?.is529
        this.isMoneyMarket =
          this.disclaimersModel.profile?.fundFact?.isMoneyMarket
        this.isInternal = this.disclaimersModel.profile?.isInternalFund
        this.isExternal = this.disclaimersModel.profile?.isExternalFund
        this.isTaxExempt = this.disclaimersModel.profile?.fundFact?.isTaxExempt
        this.isREITFund = this.disclaimersModel.profile?.fundFact?.isREITFund
        this.secDesignation = this.disclaimersModel.profile?.secDesignation
        this.newEtfSplit = this.disclaimersModel.content?.newEtfSplit
        if (this.newEtfSplit !== undefined) {
          this.newEtfSplit = this.centralContentService.formatLink(
            this.newEtfSplit,
          )
        }
      })
    //------- AEM content call ---------
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }
  parseAEMContent(content) {
    {
      this.externalAssetClassRisks =
        this.centralContentService.getContentByBody(
          'disclaimer_assetclass_risks',
          content,
        )
      this.externalThirdPartyCalculations =
        this.centralContentService.getContentByBody(
          'disclaimer_non_vanguard_third_party_price_calculations',
          content,
        )
      this.externalMFDataSources = this.centralContentService.getContentByBody(
        'disclaimer_non_vanguard_mf_data_sources',
        content,
      )
      this.externalMFFeesMinimums = this.centralContentService.getContentByBody(
        'disclaimer_non_vanguard_mf_fees_and_minimums',
        content,
      )
      this.externalMFInvestingProspectus =
        this.centralContentService.getContentByBody(
          'disclaimer_non_vanguard_mf_investing_prospectus',
          content,
        )
      this.etfVanguardAverageExpenseRatio =
        this.centralContentService.getContentByBody(
          'disclaimer_etf_vanguard_average_expense_ratio',
          content,
        )
      this.morningstarAllRightsReserved =
        this.centralContentService.getContentByBody(
          'disclaimer_morningstar_all_rights_reserved',
          content,
        )
      this.etfSharesRedeemable = this.centralContentService.getContentByBody(
        'disclaimer_etf_shares_redeemable',
        content,
      )
      this.mfVanguardAverageExpenseRatio =
        this.centralContentService.getContentByBody(
          'disclaimer_mf_vanguard_average_expense_ratio',
          content,
        )
      this.p529ProgramDescriptionLink1 =
        this.centralContentService.getContentByBody(' ', content)
      this.p529ProgramDescription = this.centralContentService.getContentByBody(
        'disclaimer_p529_program_description',
        content,
      )
      this.p529ProgramDescriptionLink2 =
        this.centralContentService.getContentByBody(
          'disclaimer_p529_program_description_link2',
          content,
        )
      this.mfTaxableMoneyMarketLoseMoney =
        this.centralContentService.getContentByBody(
          'disclaimer_mf_taxable_money_market_lose_money',
          content,
        )
      this.mfTaxExemptMoneyMarketLoseMoney =
        this.centralContentService.getContentByBody(
          'disclaimer_mf_tax_exempt_money_market_lose_money',
          content,
        )
      this.mfInvestingSubjectToRisk =
        this.centralContentService.getContentByBody(
          'disclaimer_mf_investing_subject_to_risk',
          content,
        )
      // Updating the Vanguard Personal link based on the current environment
      if (this.p529ProgramDescriptionLink1?.contentValue) {
        this.updatedLink =
          this.p529ProgramDescriptionLink1?.contentValue.replace(
            '{{url}}',
            this.personalLink,
          )
        this.p529ProgramDescriptionLink1.contentValue = this.updatedLink
      }
      if (this.p529ProgramDescriptionLink2?.contentValue) {
        this.updatedLink =
          this.p529ProgramDescriptionLink2?.contentValue.replace(
            '{{url}}',
            this.personalLink,
          )
        this.p529ProgramDescriptionLink2.contentValue = this.updatedLink
      }
      if (!this.p529ProgramDescriptionLink2) {
        this.p529ProgramDescriptionLink2 =
          this.centralContentService.formatLink(
            this.p529ProgramDescriptionLink2,
          )
      }
    }
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
